import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-alumni-meet',
  templateUrl: './alumni-meet.component.html',
  styleUrls: ['./alumni-meet.component.scss']
})
export class AlumniMeetComponent implements OnInit {
  activeTab: 'description' | 'gallery' | 'registered' | 'sessions' = 'description';

  moments = [
    'alumni_monent_img-711x400.jpg',
    'alumni_monent_img22-600x400.jpg',
    'alumni_monent_img23-600x400.jpg',
    'alumni_monent_img24-600x400.jpg',
    'alumni_monent_img25-267x400.jpg',
    'alumni_monent_img26-600x400.jpg',
    'alumni_monent_img27-267x400.jpg',
    'alumni_monent_img28-267x400.jpg',
    'alumni_monent_img29-600x400.jpg',
    'alumni_monent_img30-600x400.jpg',
    'alumni_monent_img31-267x400.jpg',
    'alumni_monent_img32-267x400.jpg',
    'alumni_monent_img33-600x400.jpg',
    'alumni_monent_img34-600x400.jpg',
    'alumni_monent_img35-267x400.jpg',
    'alumni_monent_img36-267x400.jpg',
    'alumni_monent_img38-600x400.jpg',
    'alumni_monent_img39-600x400.jpg',
    'alumni_monent_img40-600x400.jpg',
    'alumni_monent_img41-600x400.jpg',
    'alumni_monent_img42-711x400.jpg',
    'alumni_monent_img43-711x400.jpg',
    'alumni_monent_img44-711x400.jpg',
    'alumni_monent_img46-711x400.jpg',
    'alumni_monent_img47-800x358.jpg',
    'alumni_monent_img48-800x358.jpg'
  ];

  memories = [
    'alumni_memories_img1-533x800.jpg',
    'alumni_memories_img12-533x800.jpg'
  ];

  selectedFolder: 'moments' | 'memories' | null = null;

  constructor() { }

  ngOnInit(): void {
  }

  setActiveTab(tab: 'description' | 'gallery' | 'registered' | 'sessions') {
    this.activeTab = tab;
    if (tab !== 'gallery') {
      this.selectedFolder = null;
    }
  }

  selectFolder(folder: 'moments' | 'memories' | null) {
    this.selectedFolder = folder;
  }

}
